import React from "react";
import "./Footer.css";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import NewsletterSubscribe from "../components/NewsletterSubscribe";

export default function Footer() {
  return (
    <footer className="footer">
      {/* Top: Newsletter */}
      <NewsletterSubscribe />

      {/* Bottom row: social + copyright */}
      <div className="footer-bottom">
        <div className="footer-left">
          <div className="footer-icons">
            <a href="https://linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer" aria-label="Linkedin link">
              <FaLinkedin />
            </a>
            <a href="https://twitter.com/yourhandle" target="_blank" rel="noopener noreferrer" aria-label="Twitter link">
              <FaTwitter />
            </a>
            <a href="https://github.com/yourusername" target="_blank" rel="noopener noreferrer" aria-label="Github link">
              <FaGithub />
            </a>
          </div>
        </div>
        <div className="footer-right">
          <p>© 2025 Babak. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
